import getAPIbaseURL from './helpers';
export const getProfilePictureUrl = (user) => {
    if (!user?.profile_picture) return null;

    if (user.profile_picture.startsWith("http")) {
        return user.profile_picture;
    }

    const baseUrl = getAPIbaseURL().replace(/\/$/, "");
    return `${baseUrl}${user.profile_picture}`;
};